import { useEffect } from "react";
import { isTrustedMessageOrigin } from "../utils/messagingOrigins";

/**
 * Maneja la comunicación cross-frame para sincronizar usuario con otras apps.
 * - Responde a REQUEST_USER con el usuario actual de la cookie
 * - Recibe user via postMessage y decide si setea cookie SSO o cookie local
 *
 * @param {Object} params
 * @param {() => any} params.getUserCookie
 * @param {(u:any)=>void} params.setUserAutenticate
 * @param {(u:any)=>void} params.setSSOUserCookie
 * @param {(u:any)=>void} params.setUserCookie
 */
export default function useCrossAppMessaging({
  getUserCookie,
  setUserAutenticate,
  setSSOUserCookie,
  setUserCookie,
}) {
  useEffect(() => {
    function handleMessage(event) {
      if (!isTrustedMessageOrigin(event.origin)) {
        return;
      }

      if (event.data && event.data.type === "REQUEST_USER") {
        // Responder con el usuario actual
        const currentUser = getUserCookie() || null;

        if (currentUser) {
          event.source.postMessage(
            {
              type: "USER_RESPONSE",
              user: currentUser,
            },
            event.origin
          );
        } else {
          event.source.postMessage(
            {
              type: "NO_USER",
            },
            event.origin
          );
        }
      } else if (event.data && event.data.user) {
        const isSSO =
          event.data.type === "sso_login" ||
          event.data.source === "owly-frontend-chat";
        setUserAutenticate(event.data.user);
        if (isSSO && typeof setSSOUserCookie === "function") {
          // Solo cookie SSO
          setSSOUserCookie(event.data.user);
        } else {
          // Login manual sincronizado desde otro frame / aplicación -> solo autenticator_user
          setUserCookie(event.data.user);
        }
      }
    }

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [getUserCookie, setUserAutenticate, setSSOUserCookie, setUserCookie]);
}
